/**
 * Pure, framework-free guard for the VOICE auto-close path.
 *
 * After the widget detects a user "goodbye" (detectUserGoodbye), it waits for
 * the bot's next reply and then closes the session. This decides whether the
 * bot's reply actually CONFIRMS the end — so a spurious goodbye does not hang
 * up mid-conversation.
 *
 * Lives as plain JS (not .ts) so node:test can import and behaviorally test it,
 * while run-realtime-event.ts imports the exact same logic.
 *
 * REGRESSION CONTEXT (July 2026): a Yuli/Callega demo call ended mid-sentence
 * and popped the end-of-call "leave your details" form. The user had asked for
 * MORE explanation, but the ASR mistranscribed it as "ביי ביי"; detectUserGoodbye
 * fired and the widget closed after the bot's next turn — even though that turn
 * was a continuation QUESTION ("...מה דעתך?"). The model clearly kept the
 * conversation going, so the widget must not override it and close.
 *
 * Rule: if the bot's reply asks the user a question, the call is NOT over.
 *
 * @param {string} botMsg raw assistant reply text (the turn after the goodbye)
 * @returns {boolean} true = safe to close after the bot finishes; false = keep open
 */
export function botReplyConfirmsEnd(botMsg) {
  const raw = String(botMsg || '').trim()
  if (!raw) {
    return true // nothing said → nothing to continue
  }
  // The bot asked the user something → it wants to continue, don't close.
  if (/[?؟]/.test(raw)) {
    return false
  }
  return true
}
